<script setup lang="ts">
import { Toaster as SonnerPrimitive } from 'vue-sonner';
import 'vue-sonner/style.css';

const baseToast = 'group pointer-events-auto flex w-full max-w-sm overflow-hidden rounded-lg border-l-4 bg-white p-4 shadow-lg ring-1 ring-black/5';

const toastOptions = {
    unstyled: true,
    classes: {
        toast: baseToast,
        title: 'text-sm font-medium',
        description: 'mt-1 break-words text-sm text-gray-600',
        icon: 'mr-3 shrink-0',
        closeButton: 'absolute right-2 top-2 flex size-7 items-center justify-center rounded-sm text-gray-600 transition hover:text-gray-800 focus:text-gray-800 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-300 [&_svg]:size-5',
        success: 'border-green-600 [&_[data-title]]:text-green-700 [&_[data-icon]]:text-green-600',
        info: 'border-blue-600 [&_[data-title]]:text-blue-700 [&_[data-icon]]:text-blue-600',
        warning: 'border-yellow-600 [&_[data-title]]:text-yellow-700 [&_[data-icon]]:text-yellow-700',
        error: 'border-red-600 bg-red-50 [&_[data-title]]:text-red-700 [&_[data-description]]:text-red-700 [&_[data-icon]]:text-red-600 [&_[data-close-button]]:text-red-600 [&_[data-close-button]]:hover:text-red-700',
    },
};
</script>

<template>
    <SonnerPrimitive
        class="toaster group"
        position="bottom-right"
        :toast-options="toastOptions"
        close-button
    />
</template>
